<div class="outer-container">
  <div class="container">
    <br/>
    <h3>Activity submissions are closed for the {{fraternalYear}} fraternal year.</h3>
    <h3>Thank you for all that you do!</h3>
    <br/>
    <p>Did you know you can still submit activities to Supreme via Form 10784 found on Supreme's website?  Activities submitted now through the end of the fraternal year via Form 10784 will not count toward the State General Program, however they can be used toward the Columbian Award application.
      <br/><br/>Click the button below to open Supreme's website.</p>
      <br/>
      <div style="width: auto; text-align: center;">
        <button style="width: auto" mat-raised-button color="primary" (click)="openSupremeSite()">Supreme Form 10784 <mat-icon style="width: auto">open_in_new</mat-icon></button>
      </div>
      <br/><br/>
      <p>Please watch <a href="https://site-842560.bcvp0rtal.com/detail/videos/forms_/video/6222163148001/fraternal-programs-report-form-10784-training-video" target="_blank">this video</a> to learn how to submit Form 10784.</p>
  </div>
</div>

